'use client'

import { PlusIcon } from '@heroicons/react/20/solid'
import { Button } from '@tebuto/buttons/Button'
import LoginButton from '@tebuto/buttons/Login'
import { useLoginStatus } from '@tebuto/functions/hooks'
import { LoginStatusGuard } from '@tebuto/guards/LoginStatus'
import { useEffect, useState } from 'react'
import FeatureModal, { FeatureForm } from './FeatureModal'

interface NewFeatureModalProps {
    createNewFeature: (values: FeatureForm) => Promise<void>
    initialIsLoggedIn?: boolean
}

function CreateNewFeatureSection({ createNewFeature }: { createNewFeature: (values: FeatureForm) => Promise<void> }) {
    const [open, setOpen] = useState<boolean>(false)
    const [hasHydrated, setHasHydrated] = useState<boolean>(false)
    const isUserLoggedIn = useLoginStatus()

    useEffect(() => {
        setHasHydrated(true)
    }, [])

    if (!hasHydrated) return <div className="mt-6 sm:mt-0 h-10 shrink-0" aria-hidden="true" />

    if (!isUserLoggedIn)
        return (
            <LoginButton
                app="landing"
                className="mt-6 sm:mt-0 shrink-0"
                title="Anmelden um ein Feature vorzuschlagen"
            />
        )

    return (
        <>
            <Button
                className="mt-6 sm:mt-0 shrink-0 whitespace-nowrap inline-flex items-center gap-2"
                onClick={() => setOpen(true)}
            >
                <PlusIcon className="size-4 shrink-0" aria-hidden="true" />
                Feature vorschlagen
            </Button>
            <FeatureModal open={open} setOpen={setOpen} submitHandler={createNewFeature} isCreation />
        </>
    )
}

export function NewFeatureModal({ createNewFeature, initialIsLoggedIn = false }: NewFeatureModalProps) {
    return (
        <LoginStatusGuard initialIsLoggedIn={initialIsLoggedIn}>
            <CreateNewFeatureSection createNewFeature={createNewFeature} />
        </LoginStatusGuard>
    )
}
